import React from 'react'
import { ListView } from 'components'
import AuditSectionLinks from 'pages/audit/AuditSectionLinks.jsx'
import { format } from 'date-fns'

function ViewReportList(_props) {
  const {
    filterActions = [],
    query,
    columnDefinition = [],
    fixedParams,
    rowIdKey,
    search = null,
    filterCustomParams = {},
    filterPresets = [],
  } = _props

  return (
    <>
      <ListView
        queryHook={query}
        filterBarPresets={filterPresets}
        fixedParams={{ ...fixedParams }}
        filterPresetParamName={'actionid'}
        filterCustomParams={filterCustomParams}
        linksComponent={AuditSectionLinks}
        columns={columnDefinition}
        rowIdKey={rowIdKey}
        rowClickHandler={() => {}}
        search={search}
      />
    </>
  )
}

export default ViewReportList
